import styled from 'styled-components'

import { devices, } from '../Common'
import { colors } from './Colors'

export const Form = styled.form`
    display: flex;
    flex-direction: column;
`

export const FormError = styled.div`
    display: block;
    color: ${colors.red};
    font-weight: bold;
    font-size: 10px;
    letter-spacing: 0px;
    margin-bottom: 10px;
`

export const Input = styled.input`
    background: ${({ color }) => color};
    border: none;
    font-size: 25px;
    margin-bottom: 5px;
    outline: none;
    color: ${colors.white};
    padding: 10px;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
`

export const Textarea = styled.textarea`
    background: ${colors.inputRed};
    border: none;
    font-size: 25px;
    margin-bottom: 5px;
    color: ${colors.white};
    resize: none;
    outline: none;
    padding: 10px;
    height: 100px;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
`

export const MultiChoiceInput = styled.label`
    /* margin-left: 10px; */
    color: ${colors.white};
    /* margin: 10px 0; */

    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    user-select: none;

    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;

        &:checked ~ span {
            background-color: ${colors.red};
            &:after {
                display: block;
            }
        }

    }

    span {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: ${colors.white};

        &:after {
            content: "";
            position: absolute;
            display: none;
            left: 9px;
            top: 5px;
            width: 5px;
            height: 10px;
            border: solid white;
            border-width: 0 3px 3px 0;
            transform: rotate(45deg);
        }
    }
`